import { render } from "./V10StyleBottom.vue?vue&type=template&id=324be59c&scoped=true"
import script from "./V10StyleBottom.vue?vue&type=script&lang=js"
export * from "./V10StyleBottom.vue?vue&type=script&lang=js"

import "./V10StyleBottom.vue?vue&type=style&index=0&id=324be59c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324be59c"]])

export default __exports__